<template>
  <swiper-content>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img
            src="5g/page-5g-header-1.svg"
            class="header-image"
            style="margin-bottom: 24px"
          />
          <p>
            Singtel is the first to harness the 3.5GHz spectrum, bringing you
            speeds of over 1Gbps. The future you once envisioned is now a
            reality.
          </p>
          <p>
            With 5G connectivity from Singtel, you can always do more at once,
            with data speeds that are up to 10x faster.
          </p>

          <img src="5g/5g-body-image.png" class="body-image" />
          <p style="margin-bottom: 0px">Explore more benefits:</p>
          <div
            style="
              margin-top: 16px;
              display: grid;
              grid-template-columns: 50% 50%;
              grid-gap: 0px 16px;
            "
          >
            <button
              class="st-button-red-outline"
              style="
                margin-bottom: 16px !important;
                font-size: 1.5vh;
                width: fit-content;
                text-align: center;
                margin-left: auto;
                margin-right: auto;
              "
              @click="playVideo('video-call')"
            >
              Augmented Reality
            </button>
            <button
              class="st-button-red-outline"
              style="
                margin-bottom: 16px !important;
                font-size: 1.5vh;
                width: fit-content;
                text-align: center;
                margin-left: auto;
                margin-right: auto;
              "
              @click="playVideo('video-city')"
            >
              Virtual Reality
            </button>
            <button
              class="st-button-red-outline"
              style="
                margin-bottom: 16px !important;
                font-size: 1.5vh;
                width: fit-content;
                text-align: center;
                margin-left: auto;
                margin-right: auto;
              "
              @click="playVideo('video-speedtest')"
            >
              Ultra-fast Speed
            </button>
            <button
              class="st-button-red-outline"
              style="
                margin-bottom: 16px !important;
                font-size: 1.5vh;
                width: fit-content;
                text-align: center;
                margin-left: auto;
                margin-right: auto;
              "
              @click="playVideo('video-vrar')"
            >
              Cloud Gaming
            </button>
          </div>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img src="5g/page-5g-header-2.svg" class="header-image" />
          <p>
            Dive into our 5G Demo Room for an immersive experience that puts the
            spotlight on VR Events, Cloud Gaming, Mixed Reality and AR Books.
          </p>
          <a
            target="_blank"
            href="https://5g.apps.aws.singtel.com/#/"
            role="button"
            class="st-button-red-outline page-button-bottom"
          >
            5G Demo Room
          </a>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img src="5g/page-5g-header-3.svg" class="header-image" />
          <h2></h2>
          <p>
            Experience Singapore’s fastest 5G speeds on your new iPhone when you
            purchase an extra 10GB of data at just $10/mth (U.P. $15/mth) on our
            Combo / XO plans.
          </p>
          <a
            target="_blank"
            href="https://www.singtel.com/personal/products-services/mobile/5g?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=bundle-hotspot&utm_campaign=iphone-2020-launch"
            class="st-button-red-outline page-button-bottom"
          >
            Find out more
          </a>
          <p class="small">T&amp;Cs apply. Market Trial ends Feb ‘21</p>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  //https://github.com/surmon-china/vue-awesome-swiper
  name: "VideoPage",

  data: function () {
    return {
      videos: [
        "video-call",
        "video-speedtest",
        "video-city",
        "video-vrar",
        "video-brand5g",
      ],
      playing: "video-brand5g",
    };
  },

  methods: {
    playVideo(video) {
      this.videos.forEach((hideVid) => {
        if (hideVid == video) return;
        this.$root.comms.send("singtel-setvideo", {
          title: hideVid,
          state: "hide",
        });
      });
      this.setVideo("play", video);
      this.setMusic("pause");
      this.playing = video;
      this.setContentEnabled(false);
    },
    setMusic(state) {
      this.$root.comms.send("singtel-setaudio", {
        title: "music",
        state: state,
      });
    },
    setVideo(state, video) {
      this.$root.comms.send("singtel-setvideo", {
        title: video,
        state: state,
      });
    },
    setContentEnabled(enabled) {
      this.$emit("setContentEnabled", enabled);
    },
  },
  mounted: function () {},
  beforeDestroy: function () {
    var self = this;
    this.videos.forEach(function (video) {
      self.setVideo("pause", video);
      self.setVideo("hide", video);
    });
  },
};
</script>

<style scoped></style>
